import { rem, rgba } from 'polished';
import styled from 'styled-components';

import { IBasicUserType } from '../../types';
import { IStyledButtonProps } from './DropDownChoiceBox.types';

export const StyledArrow = styled.span`
  display: flex;
  margin-left: ${rem('8px')};

  svg {
    width: ${rem('10px')};
    height: auto;
  }
`;

export const StyledButton = styled.button<IStyledButtonProps>`
  display: inline-flex;
  align-items: center;
  height: ${rem('40px')};
  padding: 0 ${rem('16px')};
  color: ${({ active, theme }) =>
    active ? theme.colors.main : theme.colors.cross.black};
  font-size: ${rem('16px')};
  font-weight: 400;
  line-height: 1.4;
  background-color: ${({ active, theme, user }) =>
    active
      ? user
        ? theme.colors[user].main
        : theme.colors.cross.silverFox
      : theme.colors.cross.lightGray};
  border: none;
  border-radius: ${rem('20px')};
  cursor: pointer;
  appearance: none;

  &[aria-expanded='true'] {
    ${StyledArrow} {
      transform: rotate(180deg);
    }
  }

  &:focus {
    outline: none; //TODO add proper focus style
  }

  ${StyledArrow} {
    svg path {
      fill: ${({ active, theme }) =>
        active ? theme.colors.main : theme.colors.cross.black};
    }
  }
`;

export const StyledCancelButton = styled.button<IBasicUserType>`
  display: inline-flex;
  padding: 0;
  background-color: transparent;
  border: none;
  color: ${({ theme, user }) =>
    user ? theme.colors[user].main : theme.colors.cross.black};
  font-weight: 700;
  font-size: ${rem('16px')};
  text-decoration: underline;
  cursor: pointer;
  appearance: none;
  white-space: nowrap;
  margin-right: ${rem('24px')};

  &[aria-disabled='true'] {
    color: ${({ theme }) => theme.colors.cross.grayson};
    cursor: default;
    opacity: 0.4;
    pointer-events: none;
  }
`;

export const StyledChoiceNav = styled.nav`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: ${rem('16px')};
  border-top: 1px solid ${({ theme }) => theme.colors.cross.lightGray};
`;

export const StyledContent = styled.div`
  position: absolute;
  top: ${rem('48px')};
  z-index: 3;
  background-color: ${({ theme }) => theme.colors.main};
  border-radius: ${rem('16px')};
  box-shadow: 0 0 ${rem('8px')} 0
    ${({ theme }) => rgba(theme.colors.cross.silverFox, 0.5)};
`;

export const StyledContentInner = styled.div`
  padding: ${rem('16px')};
`;

export const StyledNav = styled.nav`
  position: relative;
  display: inline-flex;
`;
